<template>
  <div class="popup">
    <div class="popup_cover"></div>
    <div class="consent-popup">
      <div class="popup-header">
        <div class="popup_title">사용인감 동의서</div>
        <img src="@/assets/images/close_btn.png" @click="confirmSelection(false)" class="close_icon" />
      </div>
      <div class="popup-body">
        <div class="contents_body">
          본인은 [<span style="font-weight: bold;">{{사업자명}}</span>]에서 요구하는 제반 업무 및 계약 등에 있어 사용인감을 사용하는 것에 동의합니다. 
          이에 따라 본인이 날인한 사용인감은 법적 효력을 가지며, 이에 대한 모든 책임은 본인에게 있음을 확인합니다.
        </div>
      </div>
      <div class="popup-footer">
        <div class="popup_confirm_btn" @click="confirmSelection(true)">동의</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits, ref, onMounted } from "vue";

const emit = defineEmits(["closePopup"]);
const props = defineProps<{ 사업자명: string}>();

const 사업자명 = ref<string | null>(null);
// 컴포넌트가 마운트될 때 props.status 값을 초기화
onMounted(() => {
  사업자명.value = props.사업자명;
});


// 선택한 상태를 부모 컴포넌트로 emit
const confirmSelection = (flag: boolean) => {
  
  emit("closePopup", { popupType: "consent", refresh: false, selectedData: flag });
};
</script>

<style scoped>
.popup {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
}
.popup_cover {
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
}
.consent-popup {
  position: fixed;
  background-color: white;
  width: 600px;
  background: white;
  top: calc(50% - 245px);
  left: calc(50% - 300px);
  border-radius: 11px;
  padding-bottom: 22px;
}
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 71px;
  padding: 22px 27px 22px 40px;
  border-bottom: 1px solid #dbdbdb;
}
.popup_title {
  font-size: 20px;
  font-family: "Noto Sans CJK KR-Bold";
  letter-spacing: -0.05em;
  color: black;
}
.popup-body {
  /* margin-top: 10px; */
  padding: 20px 40px;
  height: calc(100% - 127px);
}
.popup-footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 0px 40px;
  gap: 10px;
}
.popup_confirm_btn {
  width: 132px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #282b33;
  border-radius: 6px;
  font-family: "Noto Sans CJK KR-Bold";
  color: white;
  font-size: 14px;
  cursor: pointer;
  background: #3382e9;
  color: #fff;
}
.close_icon {
  cursor: pointer;
}
.contents_body {
  height: 100%;
  gap: 10px;
}
.contents_div {
  display: flex;
  align-items: center;
  gap: 12px;
  border: 2px solid #eeeeee;
  padding: 20px 15px;
  justify-content: center;
  cursor: pointer;
}
/*  */
.contents_div {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
}

/* 선택되지 않은 항목에만 hover 스타일 적용 */
.contents_div:not(.selected):hover {
  background-color: #f0f0f0;
}

/* 선택된 항목 스타일 */
.selected {
  background-color: #222957;
  color: white;
  font-weight: bold;
}

.popup_confirm_btn {
  cursor: pointer;
}

.close_icon {
  cursor: pointer;
}
</style>
